type ErrorLogLevel = 'error' | 'warning' | 'info';
type ConsoleMethod = 'error' | 'warn' | 'info';
type ErrorContext = Record<string, string | number | boolean | null | undefined>;

const logLevelToConsoleMethod: Record<ErrorLogLevel, ConsoleMethod> = {
  error: 'error',
  warning: 'warn',
  info: 'info'
};

export const logError = (error: Error | unknown, level: ErrorLogLevel = 'error', context?: ErrorContext) => {
  const errorObject = {
    timestamp: new Date().toISOString(),
    level,
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : undefined,
    ...context
  };

  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console[logLevelToConsoleMethod[level]](errorObject);
  }

  // Here you could add additional error reporting services
  // e.g., Sentry, LogRocket, etc.
}; 